var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"spinner",staticStyle:{"bottom":"0"}},[_c('span',{staticClass:"bx"}),_vm._v(" "),_c('span',{staticClass:"by"})])])
}]

export { render, staticRenderFns }